import { FormFooter, FormFooterCancel, FormFooterSubmit } from 'components';
import { useFormPrompt } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { useFormContext } from 'modules/operation/common/forms/operationForm';

export interface OperationFormFooterProps {
  submitLoading: boolean | undefined;
  onBack: () => void;
}

export const OperationFormFooter = ({
  submitLoading,
  onBack,
}: OperationFormFooterProps) => {
  const { t } = useTranslation();
  const { submitDisabled } = useFormContext();

  useFormPrompt();

  return (
    <FormFooter>
      <FormFooterCancel label={t('common.back')} onClick={onBack} />
      <FormFooterSubmit
        disabled={submitDisabled}
        label={t('common.add')}
        loading={submitLoading}
      />
    </FormFooter>
  );
};
